export default {
  "update-error": {
    EN: "Failed to update the User Account. Please refresh and try again later.",
  },
  "update-failed": {
    EN: "Failed to update the User Account. Please try again.",
  },
  "update-success": {
    EN: "Successfully updated the User Account.",
  },
  "invite-success": {
    EN: "Successfully invited User",
  },
  "invite-failure": {
    EN: "Failed to invite User. Please try again in a few minutes.",
  },
};
